// eslint-disable-next-line
export enum BenefitType {
  PLUG_AND_PLAY = "plug-and-play",
  CORE = "core",
  CUSTOM = "custom",
}
